import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCheckCircle, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const SuccessModal = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          {/* Overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-slate-900/80 backdrop-blur-sm"
            onClick={onClose}
          />

          {/* Modal */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="relative w-[95%] max-w-md bg-gradient-to-b from-white to-slate-50 
              rounded-2xl shadow-2xl p-6 md:p-8 border border-slate-100 mx-4"
          >
            <div className="text-center">
              {/* Success Icon */}
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2, type: "spring" }}
                className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6
                  shadow-lg shadow-green-100 border-2 border-green-200"
              >
                <FaCheckCircle className="w-8 h-8 text-green-500" />
              </motion.div>

              {/* Title */}
              <h2 className="text-2xl font-bold text-slate-800 mb-3">
                Candidature Soumise avec Succès !
              </h2>

              {/* Message */}
              <p className="text-slate-600 text-sm leading-relaxed mb-6">
                Merci d'avoir postulé au Master Spécialisé en Intelligence Artificielle et IoT. 
                Votre candidature a été reçue et est en cours d'examen par notre équipe.
              </p>

              {/* Next Steps */}
              <div className="bg-blue-50/70 rounded-xl p-5 mb-6 border border-blue-100">
                <h3 className="font-semibold text-blue-900 mb-3 text-sm">
                  Prochaines étapes :
                </h3>
                <ul className="text-left text-blue-800/90 space-y-3 text-sm">
                  <li className="flex items-center gap-3">
                    <FaPhoneAlt className="text-blue-500 w-4 h-4 flex-shrink-0" />
                    <span>Notre équipe vous contactera dans les plus brefs délais pour planifier un entretien</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <FaEnvelope className="text-blue-500 w-4 h-4 flex-shrink-0" />
                    <span>Vous recevrez un email de confirmation avec plus de détails</span>
                  </li>
                </ul>
              </div>

              {/* Contact Info */}
              <div className="text-xs text-slate-500 mb-6">
                Pour toute question, n'hésitez pas à nous contacter :
                <div className="mt-1 space-x-2">
                  <a href="tel:+212679791682" className="text-blue-600 hover:text-blue-700 font-medium">
                    06 79 79 16 82
                  </a>
                  <span className="text-slate-300">|</span>
                  <a href="mailto:mohamed.hamlich@ensam-casa.ma" className="text-blue-600 hover:text-blue-700 font-medium">
                    mohamed.hamlich@ensam-casa.ma
                  </a>
                </div>
              </div>

              {/* Close Button */}
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={onClose}
                className="bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 
                  text-white font-medium px-6 py-2.5 rounded-lg shadow-lg transition-all duration-300
                  text-sm w-full max-w-[200px]"
              >
                Fermer
              </motion.button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default SuccessModal; 